import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import _ from "lodash"
import axios from "axios"
import settings from "settings"
import userToken from "helpers/userToken"
import { Formik, Field, Form } from "formik"
import submitData from "helpers/submitData"
import { toast } from "react-toastify"
import TagsInput from "react-tagsinput"
import { loadingStatus, getPayload } from "actions"

class RealtorBrokerages extends Component {
	constructor(props) {
		super(props)

		this.state = {
			q: "",
			record: {},
			loaded: false,
			teams: [],
			fields: {
				teams: [],
				offices: [],
				dba: ''
			}
		}
	}

	submit = () => {
		var user = userToken()
		let ret = new Promise((resolve, reject) => {
			axios
				.post(
					settings.ep + "/trecLookup",
					{ q: this.state.q },
					{ headers: { Authorization: `Bearer ${user}` } }
				)
				.then((json) => {
					if (json) {
						resolve(json.data)
					} else {
						reject("No brokerage found with given license number.")
					}
				})
				.catch((error) => {
					reject("No brokerage found with given license number.")
				})
		})
		ret.then((data) => {
			console.log(data)
			let state = _.cloneDeep(this.state)
			state.record = data.record
			if(data.existing) {
				state.fields.teams = data.existing.teams || []
				state.fields.dba = data.existing.dba || ""
				state.fields.offices = data.existing.offices || []
			}
			state.loaded = true
			this.setState(state)
		}).catch((e) => console.log(e))
	}

	handleChangeTeams = (v) => {
		let teams = _.uniq(v)
		this.setState({ teams })
	}

	renderTag = props => {
		// Do not allow them to remove tags due to keeping track of historical records.
		let { tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, ...other } = props
		return (
			<span key={key} {...other}>
				{getTagDisplayValue(tag)}
			</span>
		)
	}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="admin">
					<Title title="Realtor Brokerage Management" showDate={false} />
					<div className="content">
						<p>To begin, please enter the brokerage license number:</p>
						<div>
							<input type="number" onChange={(e) => this.setState({ q: e.target.value })} />
							<button type="button" className="btn" style={{ marginLeft: 15 }} onClick={this.submit}>
								Lookup
							</button>
						</div>
						{this.state.loaded && this.state.record && (
							<div className="realtorBrokerages">
								<div className="realtorBrokerages__left">
									<h2>Commission Record</h2>
									<table className="realtorBrokerages__table">
										<tbody>
											<tr>
												<td>Full Name</td>
												<td>{this.state.record.full_name}</td>
											</tr>
											<tr>
												<td>License Number</td>
												<td>{this.state.record.number}</td>
											</tr>
											<tr>
												<td>Address 1</td>
												<td>{this.state.record.mailing_address_1}</td>
											</tr>
											<tr>
												<td>Address 2</td>
												<td>{this.state.record.mailing_address_2}</td>
											</tr>
											<tr>
												<td>City</td>
												<td>{this.state.record.mailing_address_city}</td>
											</tr>
											<tr>
												<td>State</td>
												<td>{this.state.record.mailing_address_state}</td>
											</tr>
											<tr>
												<td>Zip</td>
												<td>{this.state.record.mailing_address_zip}</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div className="realtorBrokerages__right">
									<h2>Additional Records</h2>
									<Formik
										enableReinitialize
										//validateOnMount={true}
										initialValues={this.state.fields}
										//validationSchema={this.validation}
										onSubmit={(values) => {
											this.props.loadingStatus(true)
											if(!this.state.record.number) { return }
											values.brokerage = this.state.record.number
											submitData("editRealtorBrokerage", values).then((data) => {
												//return
												this.props.loadingStatus(false)
												toast.success(data.message)
												this.setState(
													{
														loaded: false,
														record: {}
													}
												)
											})
										}}>
										{(f) => (
											<Form>
												<table className="realtorBrokerages__table">
													{console.log(f)}
													<tbody>
														<tr>
															<td>Doing Business As</td>
															<td>
																<Field name="dba" type="text" className="form__input" />
															</td>
														</tr>
														<tr>
															<td style={{ paddingTop: 40 }}>Offices</td>
															<td style={{ paddingTop: 40 }}>
																<TagsInput
																	name="offices"
																	value={f.values.offices}
																	onChange={(v) => f.setFieldValue("offices", v)}
																	renderTag={this.renderTag}
																	onlyUnique={true}
																/>
															</td>
														</tr>
														<tr>
															<td style={{ paddingTop: 40 }}>Teams</td>
															<td style={{ paddingTop: 40 }}>
																<TagsInput
																	name="teams"
																	value={f.values.teams}
																	onChange={(v) => f.setFieldValue("teams", v)}
																	renderTag={this.renderTag}
																	onlyUnique={true}
																/>
															</td>
														</tr>
													</tbody>
												</table>
												<input
													type="submit"
													value="Submit"
													className="form__submit form__submit--ready"
												/>
											</Form>
										)}
									</Formik>
								</div>
							</div>
						)}
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(RealtorBrokerages)
